import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    icons: { iconfont: 'mdi' },
    theme: {
        themes: {
            light: {
                primary: "#212120",
                secondary: "#3B444F",
                accent: "#EEB826",
                error: "#f44336",
                warning: "#ff5722",
                info: "#03a9f4",
                success: "#8bc34a"
                /*thirdy: "#FDEEDC",
                secondary: "#F1A661",
                accent: "#F1A661",
                primary: "#E38B29",
                error: "#f44336",
                warning: "#ff5722",
                info: "#03a9f4",
                success: "#8bc34a"*/
                /* thirdy: "#FDEEDC",
                secondary: "#DBCBBD",
                accent: "#C87941",
                primary: "#290001",
                error: "#f44336",
                warning: "#ff5722",
                info: "#03a9f4",
                success: "#8bc34a" */
            }
        }
    }
});

/**
 * #3D5A73
 * #2F3D40
 * #455559
 * #28403D
 * #182625
 * 
 */
